import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import clsx from 'clsx';
import { isEmpty } from 'lodash';

import { GridColumn as Column } from '@progress/kendo-react-grid';

import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip';
import BobTable from '../../../components/BobTable';
import ExecutiveSummaryTile from '../../../components/ExecutiveSummaryTile';

import * as classes from './ExecutiveSummaryFaultsByRule.module.css';
import { Link } from 'react-router-dom';

const ExecutiveSummaryFaultsByRule = ({
    activeNavCompany,
    activeSite,
    bobLoading,
    extendedColumns,
    ruleFaults,
    ruleFaultsMeta,
    ...props
}) => {

    const [data, setData] = useState([]);

    useEffect(() => {
        setData(ruleFaults);
    }, [ruleFaults]);

    const nameCell = props => {
        if (isEmpty(activeSite)) { 
            return (
                <td className={props.className} style={props.style}>
                    <HtmlTooltip
                        information={<React.Fragment><div className={classes.Parent}>{`${props.dataItem[props.field]}`}</div></React.Fragment>}
                        placement="top-start"
                        body={
                            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {props.dataItem[props.field]}
                            </div>
                        }
                    />
                </td>
            );
        }
        else {
            const url = `/v2/dashboard/site?appId=ad356bf2-b9db-4bb5-922e-c3394b1a63e3&childId=25fgdf16-171c-4ee6-a753-913fdcb5457b&client=${activeSite.client.id}&company=${activeNavCompany.id}&parentId=c0c505f5-c7fc-4317-8cb6-f6e631142a77&site=${activeSite.id}&ruleId=${props.dataItem.ruleId}`;
            return (
                <td className={props.className} style={props.style}>
                    <HtmlTooltip
                        information={<React.Fragment><div className={classes.Parent}>{`${props.dataItem[props.field]}`}</div></React.Fragment>}
                        placement="top-start"
                        body={
                            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                <Link   
                                    to={url}
                                    target={'_blank'}
                                >
                                    {props.dataItem[props.field]}
                                </Link>
                            </div>
                        }
                    />
                </td>
            );                    
        }
    };

    const nameFooterCell = props => {
        return (
            <td className={props.className} colSpan={0} style={props.style}>
                Total
            </td>
        );
    };

    const totalFooterCell = props => {
        const field = props.field || '';
        const total = data.reduce((acc, current) => acc + current[field], 0);
        let imgPath = null;

        if (props.field === 'lowFaultCount') {
            imgPath = '/assets/images/low.svg';
        } else if (props.field === 'mediumFaultCount') {
            imgPath = '/assets/images/medium.svg';
        } else if (props.field === 'highFaultCount') {
            imgPath = '/assets/images/high.svg';
        }

        return (
            <td className={props.className} style={props.style}>
                {imgPath ? <img className={classes.Icon} src={imgPath} alt="" /> : null}
                {total}
            </td>
        );
    };

    const issueTypeCell = props => {
        let issueTypes = props.dataItem[props.field];

        if (!isEmpty(issueTypes)) {
            issueTypes = issueTypes.replace(/['"]+/g, '');
            issueTypes = issueTypes.split(',');
        } else {
            issueTypes = [];
        }

        return (
            <td className={clsx(props.className, classes.IssueTypeCell)} style={props.style}>
                <HtmlTooltip
                    information={<React.Fragment><div className={classes.Parent}>{issueTypes.join(', ')}</div></React.Fragment>}
                    placement="top-start"
                    body={
                        <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {issueTypes.join(', ')}
                        </div>
                    }
                />
            </td>
        );
    };

    let columns = [];

    if (extendedColumns) {
        columns = [
            <Column
                key={0}
                field="ruleName"
                title="Rule Name"
                cell={nameCell}
                footerCell={nameFooterCell}
                id="equipName"
                width={350}
            />,
            <Column
                key={6}
                field="issueTypes"
                title="Issue Types"
                cell={issueTypeCell}
                id="clientName"
                width={300}
            />,
            <Column
                key={7}
                field="totalCount"
                title="Fault Count"
                footerCell={totalFooterCell}
                id="siteName"
                width={120}
            />
        ];
    } else {
        columns = [
            <Column
                key={0}
                field="ruleName"
                title="Rule Name"
                cell={nameCell}
                footerCell={nameFooterCell}
                id="equipName"
                width="auto"
            />,
            <Column
                key={6}
                field="issueTypes"
                title="Issue Types"
                cell={issueTypeCell}
                id="clientName"
                width={180}
            />,
            <Column
                key={7}
                field="totalCount"
                title="Fault Count"
                footerCell={totalFooterCell}
                id="siteName"
                width={120}
            />
        ];
    }

    return (
        <ExecutiveSummaryTile isLoading={isEmpty(ruleFaults) || bobLoading.includes('FetchExecutiveSummaryFaultByRule')}>
            {isEmpty(ruleFaultsMeta) || bobLoading.includes('FetchExecutiveSummaryFaultByRule') ?
                <div className={classes.Loader}>
                    <img src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                </div>
                :
                <BobTable
                    altStyle={true}
                    data={data}
                    columns={columns}
                    className={classes.FaultGrid}
                    isPageable={false}
                    scroll={'scrollable'}
                />
            }
        </ExecutiveSummaryTile>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:             state.bob.activeNavCompany,
        bobLoading:                   state.bob.bobLoading,
        ruleFaults:                   state.executiveSummary.ruleFaults,
        ruleFaultsMeta:               state.executiveSummary.ruleFaultsMeta,
        targetNavCompany:             state.bob.targetNavCompany,
        worstPerformingEquipment:     state.executiveSummary.worstPerformingEquipment,
        worstPerformingEquipmentMeta: state.executiveSummary.worstPerformingEquipmentMeta
    };
};

export default connect(mapStateToProps, null)(ExecutiveSummaryFaultsByRule);
